// extracted by mini-css-extract-plugin
export default {"about_container":"aboutus_styles_about_container__VLknk","sub":"aboutus_styles_sub__dqMvw","about_content":"aboutus_styles_about_content__PrZnf"};